import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../magic_forms_2/store/hooks";
import useQuery from "../utils/UseQuery";
import {
  changeCreateAsesorRequest,
  createAsesor,
  getAsesorFieldsByCode,
  getBrandConfigByCode,
  selectAsesorCreateRequest,
  selectAsesorFields,
  selectBrandConfig,
  selectGeneratedURlForQR,
  selectLoadingAsesorFields,
  selectLoadingBrandConfig,
  selectLoadingCreateAsesor,
  selectLoadingSendEmail,
  sendEmail,
} from "./asesorSlice";
import { ReactComponent as Upload } from "../assets/Upload.svg";
import { ReactComponent as QRCode } from "../assets/qrCode.svg";
import { ReactComponent as Copy } from "../assets/copy.svg";
import ClipLoader from "react-spinners/ClipLoader";
import "./asesorStyle.css";
import { TextField } from "./components/TextField";
import { SelectInput } from "./components/SelectInput";

export const AsesorCreation = () => {
  let asesorCreateRequest = useAppSelector(selectAsesorCreateRequest);

  //get registrationId and code from query params
  const query = useQuery();
  const code = query.get("code") ?? "error";
  const registrationId = query.get("registrationId") ?? undefined;
  const authId = query.get("authId") ?? undefined;
  const loadingCreateAsesor = useAppSelector(selectLoadingCreateAsesor);
  const loadingSendEmail = useAppSelector(selectLoadingSendEmail);
  const brandConfig = useAppSelector(selectBrandConfig);
  const loadingBrandConfig = useAppSelector(selectLoadingBrandConfig);
  const asesorFields = useAppSelector(selectAsesorFields);
  const loadingAsesorFields = useAppSelector(selectLoadingAsesorFields);
  const qrUrl = useAppSelector(selectGeneratedURlForQR);

  const [page, setPage] = useState(0);
  const [fileError, setFileError] = useState("");
  const [errorMessages, setErrorMessages] = useState<
    { fieldId: string; message: string }[]
  >([]);

  let dispatch = useAppDispatch();

  const arrayBufferToBase64 = (buffer: ArrayBuffer) => {
    var binary = "";
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  };

  const checkFields = () => {
    let errors: { fieldId: string; message: string }[] = [];
    asesorFields.forEach((field) => {
      if (
        field.required &&
        !asesorCreateRequest.fillFields.find((f) => f.id === field.fieldId)
          ?.value
      ) {
        errors.push({
          fieldId: field.fieldId!,
          message: "El campo es requerido",
        });
      }
    });
    console.log(errors);
    setErrorMessages(errors);
    return errors.length === 0;
  };

  useEffect(() => {
    if (code !== "error" && (registrationId || authId)) {
      dispatch(
        changeCreateAsesorRequest({
          ...asesorCreateRequest,
          code: code,
          authId: authId ?? asesorCreateRequest.authId,
          registrationId: registrationId ?? asesorCreateRequest.registrationId,
        })
      );
    }
    if (loadingCreateAsesor === "resolved" && loadingSendEmail === "idle") {
      dispatch(sendEmail());
    }
    if (loadingSendEmail === "resolved") {
      setPage(2);
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingCreateAsesor, loadingSendEmail]);

  useEffect(() => {
    if (loadingAsesorFields === "idle") {
      dispatch(getAsesorFieldsByCode(code));
    }
    if (loadingBrandConfig === "idle") {
      dispatch(getBrandConfigByCode(code));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingAsesorFields, loadingBrandConfig]);

  const getPageInfo = () => {
    if (
      loadingCreateAsesor === "pending" ||
      loadingSendEmail === "pending" ||
      loadingBrandConfig === "pending" ||
      loadingAsesorFields === "pending"
    ) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            width: "100%",
          }}
        >
          <ClipLoader color={brandConfig.primaryTextColor} size={120} />
          <h5
            style={{
              color: brandConfig.primaryTextColor,
              marginTop: "20px",
              fontSize: "20px",
            }}
          >
            Obteniendo información
          </h5>
        </div>
      );
    } else {
      if (page === 0) {
        return (
          <div
            className="container"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "start",
              alignItems: "center",
            }}
          >
            <p
              style={{
                textAlign: "start",
                fontSize: "20px",
                fontWeight: 700,
                color: brandConfig.primaryTextColor,
                width: "100%",
                margin: "10px 0 20px 0",
              }}
            >
              Antes de terminar con tu registro ingresa la siguiente información
            </p>
            {asesorFields.map((field, index) => {
              switch (field.type) {
                case "TEXT":
                  return (
                    <TextField
                      label={field.label}
                      disabled={field.disabled}
                      inputType="text"
                      key={index}
                      placeholder={field.placeholder}
                      value={
                        asesorCreateRequest.fillFields.find(
                          (fillField) => fillField.id === field.fieldId
                        )?.value
                      }
                      primaryTextColor={brandConfig.primaryTextColor}
                      errorColor={brandConfig.errorTextColor ?? "#fa7373"}
                      errorMessage={
                        errorMessages.find(
                          (error) => error.fieldId === field.fieldId
                        )?.message
                      }
                      onChange={(e) => {
                        const currentFillField =
                          asesorCreateRequest.fillFields.find(
                            (fillField) => fillField.id === field.fieldId
                          );
                        if (currentFillField) {
                          const currentFillFields = [
                            ...asesorCreateRequest.fillFields,
                          ].filter(
                            (fillField) => fillField.id !== field.fieldId
                          );
                          currentFillFields.push({
                            ...currentFillField,
                            value: e.target.value,
                          });
                          const errorField = errorMessages.find(
                            (error) => error.fieldId === field.fieldId
                          );
                          if (errorField) {
                            setErrorMessages(
                              errorMessages.filter(
                                (error) => error.fieldId !== field.fieldId
                              )
                            );
                          }
                          dispatch(
                            changeCreateAsesorRequest({
                              ...asesorCreateRequest,
                              fillFields: currentFillFields,
                            })
                          );
                        }
                      }}
                    />
                  );
                case "NUMBER":
                  return (
                    <TextField
                      label={field.label}
                      disabled={field.disabled}
                      inputType="numeric"
                      key={index}
                      placeholder={field.placeholder}
                      value={
                        asesorCreateRequest.fillFields.find(
                          (fillField) => fillField.id === field.fieldId
                        )?.value
                      }
                      primaryTextColor={brandConfig.primaryTextColor}
                      errorColor={brandConfig.errorTextColor ?? "#fa7373"}
                      errorMessage={
                        errorMessages.find(
                          (error) => error.fieldId === field.fieldId
                        )?.message
                      }
                      onChange={(e) => {
                        const currentFillField =
                          asesorCreateRequest.fillFields.find(
                            (fillField) => fillField.id === field.fieldId
                          );
                        if (currentFillField) {
                          const currentFillFields = [
                            ...asesorCreateRequest.fillFields,
                          ].filter(
                            (fillField) => fillField.id !== field.fieldId
                          );
                          currentFillFields.push({
                            ...currentFillField,
                            value: e.target.value,
                          });
                          const errorField = errorMessages.find(
                            (error) => error.fieldId === field.fieldId
                          );
                          if (errorField) {
                            setErrorMessages(
                              errorMessages.filter(
                                (error) => error.fieldId !== field.fieldId
                              )
                            );
                          }
                          dispatch(
                            changeCreateAsesorRequest({
                              ...asesorCreateRequest,
                              fillFields: currentFillFields,
                            })
                          );
                        }
                      }}
                    />
                  );
                case "DROPDOWN":
                  return (
                    <SelectInput
                      id={field.fieldId!}
                      options={field.options!}
                      accentColor={brandConfig.accentColor}
                      errorColor={brandConfig.errorTextColor ?? "#fa7373"}
                      errorMessage={
                        errorMessages.find(
                          (error) => error.fieldId === field.fieldId
                        )?.message
                      }
                      key={index}
                      label={field.label}
                      placeholder={field.placeholder}
                      primaryTextColor={brandConfig.primaryTextColor}
                      value={
                        asesorCreateRequest.fillFields.find(
                          (fillField) => fillField.id === field.fieldId
                        )?.value
                      }
                      onChange={(e, value) => {
                        const currentFillField =
                          asesorCreateRequest.fillFields.find(
                            (fillField) => fillField.id === field.fieldId
                          );
                        if (currentFillField) {
                          const currentFillFields = [
                            ...asesorCreateRequest.fillFields,
                          ].filter(
                            (fillField) => fillField.id !== field.fieldId
                          );
                          currentFillFields.push({
                            ...currentFillField,
                            value: value,
                          });
                          const errorField = errorMessages.find(
                            (error) => error.fieldId === field.fieldId
                          );
                          if (errorField) {
                            setErrorMessages(
                              errorMessages.filter(
                                (error) => error.fieldId !== field.fieldId
                              )
                            );
                          }
                          dispatch(
                            changeCreateAsesorRequest({
                              ...asesorCreateRequest,
                              fillFields: currentFillFields,
                            })
                          );
                        }
                      }}
                    />
                  );
                default:
                  return "";
              }
            })}
            <button
              onClick={(e) => {
                e.preventDefault();
                if (checkFields()) {
                  setPage(1);
                }
              }}
              style={{
                border: "none",
                background:
                  brandConfig.primaryButtonColor ??
                  "linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%)",
                borderRadius: "30px",
                minHeight: "60px",
                color:
                  brandConfig.primaryButtonTextColor ??
                  brandConfig.secondaryTextColor ??
                  "#fff",
                fontSize: "21px",
                padding: "10px 50px 10px 50px",
                fontWeight: 600,
                fontFamily: "Open Sans",
                margin: "30px 0 10px 0",
                cursor: "pointer",
              }}
            >
              SIGUIENTE
            </button>
          </div>
        );
      } else if (page === 1) {
        return (
          <div
            className="container"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "90vh",
              overflowY: "auto",
            }}
          >
            <p
              style={{
                textAlign: "start",
                fontSize: "22px",
                fontWeight: 700,
                color: brandConfig.primaryTextColor,
                width: "100%",
                margin: "0 0 60px 0",
              }}
            >
              Para finalizar debemos cargar tu imagen de presentación
            </p>
            {asesorCreateRequest.photoBase64.length > 0 ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  margin: "0 0 35px 0",
                }}
              >
                <img
                  alt="foto subida"
                  style={{
                    width: "80%",
                    height: "auto",
                    objectFit: "cover",
                    borderRadius: "10px",
                    margin: "0 0 20px 0",
                  }}
                  src={`data:image/png;base64,${asesorCreateRequest.photoBase64}`}
                />
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(
                      changeCreateAsesorRequest({
                        ...asesorCreateRequest,
                        photoBase64: "",
                      })
                    );
                  }}
                  style={{
                    border: "none",
                    background:
                      "linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%)",
                    borderRadius: "30px",
                    height: "30px",
                    width: "50%",
                    color: "#fff",
                    fontSize: "15px",
                    textTransform: "uppercase",
                    fontWeight: 600,
                    fontFamily: "Open Sans",
                    margin: "20px 0 0 0",
                    cursor: "pointer",
                    maxWidth: "300px",
                  }}
                >
                  Escoger otra
                </button>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(createAsesor());
                  }}
                  style={{
                    border: "none",
                    background:
                      brandConfig.primaryButtonColor ??
                      "linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%)",
                    borderRadius: "30px",
                    color:
                      brandConfig.primaryButtonTextColor ??
                      brandConfig.secondaryTextColor ??
                      "#fff",
                    fontSize: "18px",
                    padding: "10px 45px 10px 45px",
                    fontWeight: 600,
                    fontFamily: "Open Sans",
                    margin: "30px 0 0px 0",
                    cursor: "pointer",
                  }}
                >
                  Continuar
                </button>
              </div>
            ) : (
              <>
                <label
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    margin: "0 0 10px 0",
                  }}
                  htmlFor="fileInput"
                >
                  <input
                    style={{ display: "none" }}
                    id="fileInput"
                    type="file"
                    accept="image/*"
                    onChange={async (e) => {
                      let file = e.target.files ? e.target.files[0] : null;
                      let type = "";
                      let fileBase64 = "";
                      if (file) {
                        type = file.type;
                        let temp = await file.arrayBuffer();
                        fileBase64 = arrayBufferToBase64(temp);
                        // check if file is image
                        if (type.includes("image")) {
                          // check if file is png or jpg

                          // check if file is less than 5mb
                          if (file.size < 5000000) {
                            // set file name
                            dispatch(
                              changeCreateAsesorRequest({
                                ...asesorCreateRequest,
                                photoBase64: fileBase64,
                              })
                            );
                            setFileError("");
                          } else {
                            setFileError("El archivo no puede ser mayor a 5mb");
                          }
                        } else {
                          setFileError("El archivo debe ser una imagen");
                        }
                      }
                    }}
                  />
                  <Upload
                    color={brandConfig.primaryTextColor}
                    width={"70px"}
                    height={"83px"}
                  />
                  <div
                    style={{
                      textAlign: "center",
                      fontSize: "14px",
                      fontWeight: 500,
                      color: brandConfig.primaryTextColor,
                      margin: "10px 0 0 0",
                    }}
                  >
                    ADJUNTAR IMAGEN
                  </div>
                  {fileError.length > 0 && (
                    <p
                      style={{
                        textAlign: "start",
                        fontSize: "12px",
                        fontWeight: 600,
                        color: brandConfig.errorTextColor ?? "#FF5C5C",
                      }}
                    >
                      {fileError}
                    </p>
                  )}
                </label>
              </>
            )}
            {!asesorCreateRequest.photoBase64 ? (
              <p
                style={{
                  textAlign: "start",
                  fontSize: "19px",
                  fontWeight: 500,
                  color: brandConfig.primaryTextColor,
                  width: "100%",
                  margin: "50px 0 0px 0",
                }}
              >
                Elige la mejor fotografía. Esta es la imagen que tus clientes
                verán al consultar tu tarjeta de asesor
              </p>
            ) : (
              <p
                style={{
                  textAlign: "start",
                  fontSize: "15px",
                  fontWeight: 500,
                  color: brandConfig.primaryTextColor,
                  width: "100%",
                  margin: "0px 0 50px 0",
                }}
              >
                Tus clientes verán esta imagen al consultar tu tarjeta de
                asesor, puedes escoger otra si deseas
              </p>
            )}
          </div>
        );
      } else if (page === 2) {
        return (
          <div
            className="container"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "90vh",
            }}
          >
            <p
              style={{
                textAlign: "start",
                fontSize: "22px",
                fontWeight: 700,
                color: brandConfig.primaryTextColor,
                width: "100%",
                margin: "0px 0 10px 0",
              }}
            >
              Revisa tu correo electrónico
            </p>
            <p
              style={{
                textAlign: "start",
                fontSize: "18px",
                fontWeight: 500,
                color: brandConfig.primaryTextColor,
                width: "100%",
                margin: "0 0 20px 0",
              }}
            >
              Te hemos enviado un código QR como este
            </p>

            <QRCode />

            <p
              style={{
                textAlign: "start",
                fontSize: "18px",
                fontWeight: 400,
                color: brandConfig.primaryTextColor,
                width: "100%",
                margin: "20px 0 30px 0",
              }}
            >
              A través de este código QR podrás ayudar a tus clientes a crear
              una vinculación
            </p>
            <p
              style={{
                textAlign: "start",
                fontSize: "18px",
                fontWeight: 400,
                color: brandConfig.primaryTextColor,
                width: "100%",
                margin: "0px 0 15px 0",
              }}
            >
              También puedes copiar el enlace de tu tarjeta de asesor y
              compartirlo
            </p>
            <button
              onClick={(e) => {
                e.preventDefault();
                navigator.clipboard.writeText(qrUrl);
              }}
              style={{
                border: "none",
                background:
                  brandConfig.primaryButtonColor ??
                  "linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%)",
                borderRadius: "30px",
                color:
                  brandConfig.primaryButtonTextColor ??
                  brandConfig.secondaryTextColor ??
                  "#fff",
                fontSize: "18px",
                padding: "10px 10px 10px 10px",
                fontWeight: 600,
                fontFamily: "Open Sans",
                margin: "0px 0 30px 0",
                cursor: "pointer",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-evenly",
                width: "230px",
              }}
            >
              Copiar Enlace
              <Copy
                width={"25px"}
                height={"25px"}
                color={
                  brandConfig.primaryButtonTextColor ??
                  brandConfig.secondaryTextColor ??
                  "#fff"
                }
              />
            </button>
            <p
              style={{
                textAlign: "center",
                fontSize: "22px",
                fontWeight: 800,
                color: brandConfig.primaryTextColor,
                width: "70%",
                margin: "40px 0 10px 0",
              }}
            >
              Ya puedes cerrar esta ventana
            </p>
          </div>
        );
      }
    }
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100vw",
        minHeight: "100vh",
        overflowX: "hidden",
        overflowY: "auto",
        background: `linear-gradient(${brandConfig.backgroundColor1}, ${brandConfig.backgroundColor2})`,
      }}
    >
      {getPageInfo()}
    </div>
  );
};
